import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';
import { databaseNoport } from '../../server/server.js';
import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';

const LotSelectMaterial = (contents) => {
    if(contents.data.length === 0){return;}
    const yearlist = contents.data.yearlist;
    const changeYear = (_yearIndex) => {
        contents.update({
            name:contents.data.name,
            yearlist:contents.data.yearlist,
            list:contents.data.list,
            index:_yearIndex
        });
    }
    const checkListLot = contents.data.list.indexOf(yearlist[contents.data.index]);
    const datalist = contents.data.list[checkListLot+1];
/*
거래처명: "주식회사 유엔아이티씨"
공급가액: "4700000"
규격: null
단가: "4700"
로트: ""
비고: null
연도: 2015
연월일: "2015-09-03"
입고: 1000
입출고번호: "2015090300001"
재고: 1000
출고: 0
코드: "10882"
*/
    return(
      <div>
        <div>{contents.data.name} / {yearlist[contents.data.index]} 년 입출고 기록</div>
        <div style={{marginLeft:'1%',display:'flex',flexDirection:'row',flexWrap:'wrap',marginBottom:'5px'}}>
          {yearlist.map((year,index)=>
           <Button key={index} variant='outlined' onClick={()=>changeYear(index)}>{year}</Button>
          )}
        </div>
        <table class="company_main" style={{width:'98%'}}>
            <thead>
              <tr>
                <th width='13%'>일시</th>
                <th width='24%'>거래처명</th>
                <th width='20%'>로트</th>
                <th width='7%'>입고</th>
                <th width='7%'>출고</th>
                <th width='9%'>재고</th>
                <th width='20%'>재고별로트</th>
              </tr>
            </thead>
            <tbody>
                {datalist.map((value,i) => 
                  <tr key={i}>
                    <td>{value.연월일}</td>
                    <td align='left'>{value.거래처명}</td>
                    <td align='left'>{value.규격}</td>
                    <td align='right'>{value.입고 === 0 ?'': value.입고}</td>
                    <td align='right'>{value.출고 === 0 ?'': value.출고}</td>
                    <td align='right'>{value.재고 === 0 ?'': value.재고}</td>
                    <td>{value.로트 === 0 ?'': value.로트}</td>
                  </tr>
                )}
            </tbody>
        </table>
      </div>
    )
}
export default LotSelectMaterial;